import { createAction, createReducer } from "@reduxjs/toolkit";

export const fetchAll = createAction("CAMPAIGNS_FETCH_ALL");

const initialState = {
  campaigns: [],
};

const campaignsReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchAll, (state, action) => {
    state.campaigns = action.payload;
  });
});

export default campaignsReducer;

export const campaignsActions = {
  fetchAll,
};
